import { render } from "./EditTypeConsultation.vue?vue&type=template&id=44d248fa&scoped=true"
import script from "./EditTypeConsultation.vue?vue&type=script&lang=js"
export * from "./EditTypeConsultation.vue?vue&type=script&lang=js"

import "./EditTypeConsultation.vue?vue&type=style&index=0&id=44d248fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d248fa"]])

export default __exports__